<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2023-11-08 09:44:58
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-08 10:04:58
-->
<template>
  <div class="logo-bottom" :class="{ 'bar-bottom': isBar }" ref="btmComp">
    <div class="img">
      <!-- <gImg
        :src="cSrc"
        :size="logoSize"
        normal
        alt=""
      /> -->
      <img :src="cSrc" class="sImg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "my-footer",
  props: {
    block: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: [Number, String],
      default: 40,
    },
    isBar: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cSrc() {
      return `https://saas-ticket.oss-cn-beijing.aliyuncs.com/store/${this.$store.state.vpnNumber}/bottom-logo.png`;
    },
  },
  data() {
    return {
      logoSize: "182",
    };
  },
  created() {},
  mounted() {
    // this.init()
  },

  watch: {},
  methods: {
    // init() {
    // 	if (this.block) {
    // 		this.$nextTick(() => {
    // 			let btmComp = this.$refs.btmComp
    // 			btmComp.style.position = 'static'
    // 		})
    // 	}
    // }
  },
};
</script>
<style scoped lang="scss">
.logo-bottom {
  width: 100%;
  background-color: rgba(255, 0, 0, 0);
  text-align: center;
  height: 76px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* position: absolute; */
  box-sizing: border-box;
  /* margin-top: 46rpx; */
  /* bottom: env(safe-area-inset-bottom); */
  /* bottom: 50rpx; */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  img {
    height: 56px;
  }
}

.bar-bottom {
  /* bottom: calc(120rpx + env(safe-area-inset-bottom)) !important; */
  /* bottom: 120rpx !important; */
}
</style>
